// extracted by mini-css-extract-plugin
module.exports = {"profileSalesContainer":"_3FQP9EVe","showMoreContainer":"_1HJMIfY9","showMoreIcon":"Hoy1IWUV","marginBottom":"_1MIZ3fzm","showMoreSales":"_19gNrhEJ","workHistoryTitle":"W6WyScGn"};
    if(module.hot) {
      // 1746735798837
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  